import React, { Component } from "react";
import PropTypes from "prop-types";
import forceCircularTabbing from "utils/forceCircularTabbing";
import styles from "./styles.module.scss";

export const MODAL_CLOSE_BUTTON_THEME = {
    DEFAULT: "default",
    SMALL: "small"
};

export const MODAL_CONTENT_THEME = {
    DEFAULT: "default",
    CONCRETE: "concrete"
};

class Modal extends Component {
    constructor(props) {
        super(props);

        this.closeModal = this.closeModal.bind(this);
        this._handleKeyDown = this._handleKeyDown.bind(this);
        this._addCircularTabbing = this._addCircularTabbing.bind(this);
        this._modalRef = React.createRef();
    }

    _handleKeyDown(event) {
        const ESCAPE_KEY = 27;

        if (event.keyCode === ESCAPE_KEY) {
            this.closeModal();
        }
    }

    _addCircularTabbing() {
        const { isOpen } = this.props;

        if (isOpen) {
            forceCircularTabbing(this._modalRef.current);

            return;
        }
    }

    componentWillMount() {
        document.addEventListener("keydown", this._handleKeyDown);
    }

    componentDidMount() {
        this._addCircularTabbing();
    }

    componentDidUpdate(prevProps) {
        const { isOpen } = this.props;

        if (isOpen && !prevProps.isOpen) {
            this._addCircularTabbing();
        }
    }

    componentWillUnmount() {
        document.removeEventListener("keydown", this._handleKeyDown);
    }

    closeModal(event) {
        const {
            isClosable,
            onClose
        } = this.props;

        if (isClosable && onClose) {
            onClose();
        }

        event.stopPropagation();
    }

    render() {
        const {
            isOpen,
            isClosable,
            isInformational,
            closeButtonTheme,
            modalContentTheme,
            children
        } = this.props;

        if (!isOpen) {
            return null;
        }

        const modalOnClick = isInformational ? this.closeModal : (event) => event.stopPropagation();
        const closeButtonOnClick = isInformational ? () => {} : this.closeModal;
        const closeButtonExtraClass = styles[closeButtonTheme] || styles[MODAL_CLOSE_BUTTON_THEME.DEFAULT];
        const closeButtonClass = `${ styles.closeButton } ${ closeButtonExtraClass }`;
        const modalContentExtraClass = styles[modalContentTheme] || styles[MODAL_CONTENT_THEME.DEFAULT];
        const modalContentClass = `${ styles.modalContent } ${ modalContentExtraClass }`;

        return (
            <div // eslint-disable-line
                ref={ this._modalRef }
                className={ styles.showModal }
                onClick={ this.closeModal }
            >
                <div // eslint-disable-line
                    className={ modalContentClass }
                    onClick={ modalOnClick } // modalOnClick needs to call stopPropagation to prevent click event propagation
                >
                    {
                        isClosable
                        && (
                            <button
                                className={ closeButtonClass }
                                type="button"
                                aria-label="Close modal"
                                onClick={ closeButtonOnClick }
                            />
                        )
                    }
                    { children }
                </div>
            </div>
        );
    }
}

Modal.defaultProps = {
    isOpen: true,
    isClosable: true,
    isInformational: true,
    closeButtonTheme: MODAL_CLOSE_BUTTON_THEME.DEFAULT,
    modalContentTheme: MODAL_CONTENT_THEME.DEFAULT,
    onClose: () => {}
};

Modal.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    isClosable: PropTypes.bool,
    isInformational: PropTypes.bool,
    closeButtonTheme: PropTypes.string,
    modalContentTheme: PropTypes.string,
    children: PropTypes.node.isRequired,
    onClose: PropTypes.func
};

export default Modal;
